module.exports = __webpack_public_path__ + "static/pt-serif-v12-latin-700-ee6644b60b1d27136104fc826da02496.woff";